export const trizettoColStyles = {
    0: { width: '30px' },
    2: { width: '50px' },
    4: { width: '50px' },
    5: { width: '30px' },
    6: { width: '50px' }
}